(function () {
    angular
        .module('element-menu.dir', [])
        .directive('elementMenu', ['$rootScope', '$timeout', '$compile', 'plumbService','helpers', 'CANVAS_OPTS', elementMenu]);

    function elementMenu($rootScope, $timeout, $compile, plumbService) {
        return {
            transclude: true,
            templateUrl: 'app/views/templates/elements-menu.tpl.html',
            controller: ['$scope', '$http', '$sce','helpers', 'CANVAS_OPTS', function ($scope, $http, $sce, helpers, CANVAS_OPTS) {
                // extending translate method, this method not available on isolate scope
                $scope.translate = $rootScope.translate;

                $scope.actionList = false;
                $scope.conditionList = false;
                $scope.instructionsJumpTo = `<div style="max-width: 200px;"><div><img width="180" src="../../../imgs/reconnect.gif" /></div><div><p class="p-looping">${$scope.translate("canvas.looping.tooltip-menu")} <br/> ${$scope.translate("canvas.looping.tooltip-menu-2")}</p></div></div>`;

                $scope.$on('setMenuDefaults', function() {
                    if($scope.actionList || $scope.conditionList) {
                        $scope.backMenu();
                    }
                });

                $scope.setLastElem = function(evt, id) {
                    var optId = $(evt.target).parents('div.shape').attr('id');
                    plumbService.setLastElemClicked(optId || id);
                };

                $scope.selectedPanel = function ($event, id) {
                    //Controller resources: Wrap, Action and Condition List
                    var wrap = $($event.currentTarget).parents('div.wrap');

                    //adding Class active to the wrap, to be moved to the left to display panels
                    wrap.addClass('active');

                    if (id == 'actionPanel') {
                        //Display Acions List
                        $scope.actionList = true;
                        $scope.conditionList = false;
                    } else {
                        //Display Conditions List
                        $scope.conditionList = true;
                        $scope.actionList = false;
                    }
                };

                $scope.backMenu = function () {
                    var wrap = $('.wrap');
                    wrap.removeClass("active");
                    $scope.conditionList = false;
                    $scope.actionList = false;
                };

            }],
            link: function (scope, elem) {}
        }
    }
}());



// WEBPACK FOOTER //
// ./app/directives/canvas_directives/element-menu.js